// components/HomeReviewsSlider.jsx - исправленный (без отступов по бокам)
import { useState, useEffect, useRef } from 'react';
import { Box, IconButton, useMediaQuery, useTheme, Typography, CircularProgress, Alert, Link, Grid } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HomeReviewCard from './HomeReviewCard';
import axiosBase from '../../axios';

// Статичные отзывы-заглушки (на случай ошибки или отсутствия отзывов)
const staticReviews = [
  {
    id: 'static_1',
    text: 'Добрый день! Сын занимался по программе "Беспилотные автомобили на Arduino". Эта программа очень понравилась. Было сложно, но интересно. Особенно понравилась работа на лазерном станке и 3D принтере. Будем рады продолжить обучение в следующем году!',
    author: 'Мама Артёма К.',
    rating: 5,
    gender: 'female',
    programTitle: 'Беспилотные автомобили на Arduino',
    programType: 'технические направления и инженерия'
  },
  {
    id: 'static_2',
    text: 'Здравствуйте! Робототехника и беспилотные автомобили. Хочу поблагодарить за полученные ценные знания! Очень интересно и познавательно. Записались на следующий год. Будем ходить, пока можно:) спасибо большое!',
    author: 'Мама Артёма Ф.',
    rating: 5,
    gender: 'female',
    programTitle: 'Робототехника и беспилотные автомобили',
    programType: 'технические направления и инженерия'
  },
  {
    id: 'static_3',
    text: 'Спасибо, Вам большое, за привитый интерес к Ардуино), знания, умения, навыки в технической направленности) За ваш педагогический труд, доверие и уважение к нашему ребенку, за прекрасную смену "Матрица ..." и ваши уроки. Дальнейшей плодотворной работы, талантливых детей) и нескончаемого оптимизма!',
    author: 'Мама Николая К.',
    rating: 5,
    gender: 'female',
    programTitle: 'Программирование Arduino',
    programType: 'технические направления и инженерия'
  },
  {
    id: 'static_4',
    text: 'Выражаем огромную благодарность педагогам за отзывчивость, умение донести материал! Мы обучались по категории "Робот по линии" в среде Arduino. Были очень полезные уроки. Пусть у вас будет много талантливых учеников! Желаем творческих успехов!',
    author: 'Мурат, тренер по спортивной робототехнике из Казахстана',
    rating: 5,
    gender: 'male',
    programTitle: 'Робот по линии (Arduino)',
    programType: 'технические направления и инженерия'
  },
];

function HomeReviewsSlider({ bgColor }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(3);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const sliderRef = useRef(null);

  useEffect(() => {
    if (isMobile) {
      setVisibleCount(1);
    } else if (isTablet) {
      setVisibleCount(2);
    } else {
      setVisibleCount(3);
    }
  }, [isMobile, isTablet]);

  useEffect(() => {
    fetchCarouselReviews();
  }, []);

  const fetchCarouselReviews = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('========== ДЕБАГ: ЗАГРУЗКА ОТЗЫВОВ ==========');
      console.log('Запрос к /reviews/carousel...');
      const response = await axiosBase.get('/reviews/carousel');
      
      console.log('Ответ от сервера (полный):', response.data);
      console.log('Success:', response.data?.success);
      console.log('Всего отзывов на сервере:', response.data?.totalAvailable);
      
      if (response.data && response.data.success && response.data.reviews && response.data.reviews.length > 0) {
        console.log(`✅ Получено ${response.data.reviews.length} отзывов с сервера`);
        console.log('Детали отзывов:');
        response.data.reviews.forEach((review, idx) => {
          console.log(`  ${idx + 1}. ${review.author} - "${review.text.substring(0, 50)}..." - ${review.programTitle}`);
        });
        setReviews(response.data.reviews);
        setCurrentIndex(0);
      } else {
        console.log('⚠️ Нет отзывов с сервера, используем статичные (4 шт)');
        console.log('Статичные отзывы:', staticReviews.map(r => r.author));
        setReviews(staticReviews);
        setError(response.data?.message || "Отзывы появятся soon... А пока примеры");
      }
    } catch (err) {
      console.error('❌ Ошибка загрузки отзывов:', err);
      console.error('Детали ошибки:', err.response?.data || err.message);
      setReviews(staticReviews);
      setError("Не удалось загрузить свежие отзывы, но мы подготовили для вас примеры");
    } finally {
      setLoading(false);
      console.log('========== ДЕБАГ: ЗАГРУЗКА ЗАВЕРШЕНА ==========');
      console.log('Итоговое количество отзывов в state:', reviews.length);
    }
  };

  useEffect(() => {
    if (!autoPlay || loading || reviews.length <= visibleCount) return;
    
    const interval = setInterval(() => {
      setCurrentIndex(prev => 
        prev >= reviews.length - visibleCount ? 0 : prev + 1
      );
    }, 5000);
    
    return () => clearInterval(interval);
  }, [autoPlay, reviews.length, visibleCount, loading]);

  const handlePrev = () => {
    setAutoPlay(false);
    setCurrentIndex(prev => 
      prev === 0 ? Math.max(0, reviews.length - visibleCount) : prev - 1
    );
  };

  const handleNext = () => {
    setAutoPlay(false);
    setCurrentIndex(prev => 
      prev >= reviews.length - visibleCount ? 0 : prev + 1
    );
  };

  const getVisibleReviews = () => {
    if (reviews.length <= visibleCount) {
      return reviews;
    }
    
    let endIndex = currentIndex + visibleCount;
    if (endIndex > reviews.length) {
      endIndex = reviews.length;
    }
    return reviews.slice(currentIndex, endIndex);
  };

  const visibleReviews = getVisibleReviews();

  if (loading) {
    return (
      <Grid container style={{ backgroundColor: bgColor, minHeight: '60vh' }} alignItems="center" justifyContent="center">
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Загружаем отзывы...</Typography>
        </Grid>
      </Grid>
    );
  }

  if (reviews.length === 0) {
    return (
      <Grid container style={{ backgroundColor: bgColor, minHeight: '60vh' }} alignItems="center" justifyContent="center" >
        <Grid item xs={12} sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" gutterBottom>
            Пока нет отзывов
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Вы можете оставить отзыв в нашей{' '}
            <Link href="https://vk.com/cpc.tomsk" target="_blank" rel="noopener noreferrer">
              официальной группе Вконтакте
            </Link>
            {' '} или в  {' '}
            <Link href="https://2gis.ru/tomsk/firm/422740746062173/tab/reviews?m=84.996708%2C56.522099%2F16" target="_blank" rel="noopener noreferrer">
              2ГИС
            </Link>
            {' '} и {' '}
             <Link href="https://yandex.ru/maps/org/tsentr_planirovaniye_karyery/1224623504/reviews/?ll=84.990821%2C56.523081&z=16" target="_blank" rel="noopener noreferrer">
              ЯндексКартах
            </Link>
             
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid 
      container 
      style={{ backgroundColor: bgColor, paddingBottom: '70px', paddingTop: '80px' }} 
      alignItems="center" 
      justifyContent="center"
    >
      <Grid item xs={12}>
        <Typography 
          variant="h4" 
          sx={{ 
            textAlign: 'center', 
            mb: 1,
            fontWeight: 'bold',
            color: 'text.primary'
          }}
        >
          {/* Отзывы */}
          Что говорят родители и ученики
        </Typography>
        
        <Typography variant="body1" color="text.secondary"
          sx={{ 
              textAlign: 'center', 
              mb: 5,
              color: 'text.secondary'
            }}
        >
            Вы можете поделиться мнением в нашей{' '}
            <Link href="https://vk.com/cpc.tomsk" target="_blank" rel="noopener noreferrer">
              официальной группе Вконтакте
            </Link>
            {' '} или в  {' '}
            <Link href="https://2gis.ru/tomsk/firm/422740746062173/tab/reviews?m=84.996708%2C56.522099%2F16" target="_blank" rel="noopener noreferrer">
              2ГИС
            </Link>
            {' '} и {' '}
             <Link href="https://yandex.ru/maps/org/tsentr_planirovaniye_karyery/1224623504/reviews/?ll=84.990821%2C56.523081&z=16" target="_blank" rel="noopener noreferrer">
              ЯндексКартах
            </Link>
             
          </Typography>

        {/* Сообщение об ошибке */}
        {error && (
          <Alert severity="info" sx={{ mb: 3, maxWidth: 600, mx: 'auto' }}>
            {error}
          </Alert>
        )}

        {/* Кнопка обновления */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, maxWidth: 1400, mx: 'auto', px: 2 }}>
          <button
            onClick={fetchCarouselReviews}
            style={{
              background: 'none',
              border: '1px solid #ddd',
              borderRadius: '20px',
              padding: '6px 16px',
              cursor: 'pointer',
              fontSize: '13px',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            🔄 Другие отзывы
          </button>
        </Box>
        
        <Box
        sx={{
            position: 'relative',
            maxWidth: 1400,
            mx: 'auto',
            px: { xs: 1, sm: 2, md: 3 }, // Уменьшил отступы
        }}
        onMouseEnter={() => setAutoPlay(false)}
        onMouseLeave={() => reviews.length > visibleCount && setAutoPlay(true)}
        ref={sliderRef}
        >
        <Box
            sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            position: 'relative',
            minHeight: 420,
            }}
        >
            {/* Левая стрелка - теперь не наезжает */}
            {reviews.length > visibleCount && (
            <IconButton
                onClick={handlePrev}
                sx={{
                position: 'absolute',
                left: { xs: -10, sm: -15, md: -20 }, // Уменьшил выступ
                zIndex: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                boxShadow: 2,
                '&:hover': {
                    backgroundColor: 'white',
                },
                padding: { xs: 0.5, sm: 1 }, // Меньше кнопка на мобилке
                }}
            >
                <ChevronLeftIcon fontSize={isMobile ? "medium" : "large"} />
            </IconButton>
            )}

            {/* Карточки отзывов */}
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                width: '100%',
                justifyContent: 'center',
                flexWrap: 'nowrap',
                overflow: 'hidden'
              }}
            >
              {visibleReviews.map((review, index) => (
                <Box 
                  key={review.id || review._id || `review-${index}`}
                  sx={{
                    flex: `0 0 calc(${100 / visibleCount}% - ${24 * (visibleCount - 1) / visibleCount}px)`,
                    minWidth: { xs: 280, sm: 300 },
                    transition: 'transform 0.3s ease'
                  }}
                >
                  <HomeReviewCard review={review} />
                </Box>
              ))}
            </Box>

            {/* Правая стрелка */}
            {reviews.length > visibleCount && (
            <IconButton
                onClick={handleNext}
                sx={{
                position: 'absolute',
                right: { xs: -10, sm: -15, md: -20 }, // Уменьшил выступ
                zIndex: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                boxShadow: 2,
                '&:hover': {
                    backgroundColor: 'white',
                },
                padding: { xs: 0.5, sm: 1 },
                }}
            >
                <ChevronRightIcon fontSize={isMobile ? "medium" : "large"} />
            </IconButton>
            )}
          </Box>

          {/* Индикаторы (точки) */}
          {reviews.length > visibleCount && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, gap: 1 }}>
              {Array.from({ length: Math.ceil(reviews.length / visibleCount) }).map((_, i) => {
                const indicatorIndex = i * visibleCount;
                const isActive = currentIndex === indicatorIndex || 
                  (currentIndex < indicatorIndex && currentIndex + visibleCount > indicatorIndex);
                
                return (
                  <Box
                    key={i}
                    onClick={() => {
                      setCurrentIndex(i * visibleCount);
                      setAutoPlay(false);
                    }}
                    sx={{
                      width: isActive ? 24 : 8,
                      height: 8,
                      borderRadius: 4,
                      mx: 0.5,
                      bgcolor: isActive ? 'primary.main' : 'action.disabled',
                      cursor: 'pointer',
                      transition: 'all 0.3s',
                      '&:hover': {
                        bgcolor: 'primary.light',
                        width: 16,
                      },
                    }}
                  />
                );
              })}
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

export default HomeReviewsSlider;